export default (api) => ({
  getAll: () => api.get('/whitelisted-tester'),
  delete: (email) => api.delete('/whitelisted-tester', {
    data: { email }
  }),
  create: (email) => api.post('/whitelisted-tester', { email }),
})
